import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Injector, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Classifier } from '../classifier';
import { PartyIdentificationGlossaryService } from './party-identification-glossary.service';

@Pipe({
  name: 'partyIdentificationDocument',
  pure: false,
  standalone: false
})
export class PartyIdentificationDocumentPipe implements PipeTransform, OnDestroy {
  private asyncPipe: AsyncPipe;

  constructor(
    private partyIdentificationGlossaryService: PartyIdentificationGlossaryService,
    private injector: Injector
  ) {
    this.asyncPipe = new AsyncPipe(injector.get(ChangeDetectorRef));
  }

  ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  transform(value: string): string {
    if (!value) {
      return '';
    }

    return this.asyncTransform(value, this.partyIdentificationGlossaryService.beneficiaryIdentificationDocuments$);
  }

  private asyncTransform(value: unknown, classifiers$: Observable<Classifier[]>) {
    return this.asyncPipe.transform(
      classifiers$.pipe(
        take(1),
        map((classifiers) => classifiers.find((classifier) => classifier.id === value)?.label)
      )
    );
  }
}
